import { render, staticRenderFns } from "./NumerationsManager.vue?vue&type=template&id=5a5e9a84&scoped=true"
import script from "./NumerationsManager.vue?vue&type=script&lang=js"
export * from "./NumerationsManager.vue?vue&type=script&lang=js"
import style0 from "./NumerationsManager.vue?vue&type=style&index=0&id=5a5e9a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e9a84",
  null
  
)

export default component.exports